import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import cn from 'classnames'

import Icon from '../Icon/Icon'
import styles from './ButtonSmall.module.scss'

interface Props {
  path: string
  type?: 'violet' | 'white'
  className?: string
}

const ButtonSmall: React.FC<Props> = ({ path, type = 'violet', className }) => {
  const { t } = useTranslation()

  return (
    <Link to={path} className={cn(styles.small, styles[type], className)}>
      {type === 'violet' ? (
        <>
          <p>{t('button_small.all')}</p>
          <Icon name='arrow-violet' />
        </>
      ) : (
        <Icon name='arrow-next-white' />
      )}
    </Link>
  )
}

export default ButtonSmall
